export default class DeviceUtils {
  static isAndroid() {
    return typeof window.Android !== 'undefined';
  }
  static isIos() {
    return typeof window.webkit !== 'undefined';
  }
}
